import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerList } from "../../redux/actions/customerActions";
import DashboardLayout from "../dashboard/DashboardLayout";
import MultiSelectDropdown from "../../Pages/Components/MultiSelectDropdown";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../Pages/Components/SearchBar";
import SortableTable from "../../Pages/Components/SortableTable";
import { format } from "date-fns";
import { FaArrowLeft } from "react-icons/fa";
const CustomerRedemptionReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState("");
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);

  const { userInfo } = useSelector((state) => state.auth);
 const rawCustomers = useSelector((state) => state.fetchCustomerList?.customers);
const customers = Array.isArray(rawCustomers)
  ? rawCustomers
  : Array.isArray(rawCustomers?.data)
  ? rawCustomers.data
  : [];

  useEffect(() => {
    if (!userInfo?.access_token) {
      navigate("/login");
    } else {
      dispatch(fetchCustomerList(userInfo.access_token));
    }
  }, [dispatch, userInfo, navigate]);

  const filteredCustomers = customers.filter((c) => {
    const matchSearch =
      c.customer_name?.toLowerCase().includes(searchText.toLowerCase()) ||
      c.mobile?.toLowerCase().includes(searchText.toLowerCase()) ||
      c.client_name?.toLowerCase().includes(searchText.toLowerCase());
    const matchState =
      selectedStates.length === 0 || selectedStates.includes(c.state);
    const matchCity =
      selectedCities.length === 0 || selectedCities.includes(c.city);
    const matchClient =
      selectedClients.length === 0 || selectedClients.includes(c.client_name);

    return matchSearch && matchState && matchCity && matchClient;
  });

  const uniqueStates = [...new Set(customers.map((c) => c.state))];
  const uniqueCities = [
    ...new Set(
      customers
        .filter(
          (c) => selectedStates.length === 0 || selectedStates.includes(c.state)
        )
        .map((c) => c.city)
    ),
  ];
  const uniqueClients = [...new Set(customers.map((c) => c.client_name))];
  const totalCustomers = filteredCustomers.length;

  const totalAmount = filteredCustomers.reduce(
    (sum, c) => sum + (Number(c.qr_amount) || 0),
    0
  );

  const totalQRUsed = filteredCustomers.filter((c) => c.qr_id).length;

  return (
    <DashboardLayout>
      <div className="bg-priimary max-w-full mx-auto">
        <div className="flex items-center space-x-3 py-4">
          <button onClick={() => navigate(-1)} className="hover:text-gray-800">
            <FaArrowLeft size={20} />
          </button>
          <h2 className="text-2xl font-bold text-amber-600 mb-1">
            {" "}
            Redeemed Customers Report
          </h2>
        </div>

        <div className="w-3/4 flex flex-col md:flex-row items-center justify-start gap-4">
          <SearchBar
            className=""
            value={searchText}
            onChange={setSearchText}
            placeholder="Search by Customer"
          />
          <MultiSelectDropdown
            placeholder="Filter by Clients"
            options={uniqueClients.map((client) => ({
              label: client,
              value: client,
            }))}
            selectedValues={selectedClients.map((val) => ({
              label: val,
              value: val,
            }))}
            setSelectedValues={(selectedOptions) => {
              setSelectedClients(selectedOptions.map((option) => option.value));
            }}
          />

          <MultiSelectDropdown
            label="Filter by State"
            placeholder="Filter by States"
            options={uniqueStates.map((state) => ({
              label: state,
              value: state,
            }))}
            selectedValues={selectedStates.map((val) => ({
              label: val,
              value: val,
            }))}
            setSelectedValues={(selectedOptions) => {
              setSelectedStates(selectedOptions.map((option) => option.value));
            }}
          />

          <MultiSelectDropdown
            label="Filter by City"
            placeholder="Filter by City"
            options={uniqueCities.map((city) => ({ label: city, value: city }))}
            selectedValues={selectedCities.map((val) => ({
              label: val,
              value: val,
            }))}
            setSelectedValues={(selectedOptions) => {
              setSelectedCities(selectedOptions.map((option) => option.value));
            }}
          />
        </div>
        {(selectedStates.length > 0 ||
          selectedCities.length > 0 ||
          selectedClients.length > 0) && (
          <div className="w-full flex gap-6 mt-2">
            {selectedClients.length > 0 && (
              <div className="">
                <div className="text-md font-bold text-gray-950 py-2">
                  Selected Clients:
                </div>
                <div className="flex flex-wrap gap-2">
                  {selectedClients.map((client) => (
                    <span
                      key={client}
                      className="bg-amber-300 text-gray-950 px-3 py-2 rounded-full text-sm font-medium"
                    >
                      {client}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {selectedStates.length > 0 && (
              <div className="">
                <div className="text-md font-bold text-gray-950 py-2">
                  Selected States:
                </div>
                <div className="flex flex-wrap gap-2">
                  {selectedStates.map((state) => (
                    <span
                      key={state}
                      className="bg-amber-300 text-gray-950 px-3 py-2 rounded-full text-sm font-medium"
                    >
                      {state}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {selectedCities.length > 0 && (
              <div className="">
                <div className="text-md font-bold text-gray-950 py-2">
                  Selected Cities:
                </div>
                <div className="flex flex-wrap gap-2">
                  {selectedCities.map((city) => (
                    <span
                      key={city}
                      className="bg-amber-300 text-gray-950 px-3 py-2 rounded-full text-sm font-medium"
                    >
                      {city}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
        <div className=" overflow-x-auto">
          <div className="mt-4 mb-4 flex justify-between items-center bg-amber-100 p-2 rounded border border-amber-500 shadow-sm">
            <div className="text-md font-semibold text-gray-950">
              Total Customers:
              <span className="text-amber-600 ml-2">{totalCustomers}</span>
            </div>
            {/* <div className="text-md font-semibold text-gray-950">
              Total QR Used:
              <span className="text-amber-600 ml-2">{totalQRUsed}</span>
            </div> */}
            <div className="text-md font-semibold text-gray-950">
              Total Amount:
              <span className="text-amber-600 ml-2">
                ₹{totalAmount.toFixed(2)}
              </span>
            </div>
          </div>

          <div className="mt-6 border border-b-amber-500">
            <SortableTable
              columns={[
                { key: "redeemed_at", label: "Date", sortable: true },
                { key: "customer_name", label: "Customer", sortable: true },
                {key:"order_remarks", label: "Order Name",sortable:true},
                { key: "mobile", label: "Mobile", sortable: true },
                { key: "client_name", label: "Client Name", sortable: true },
                { key: "qr_id", label: "QR Code", sortable: true },
                { key: "qr_amount", label: "Amount", sortable: true },
                { key: "city", label: "City", sortable: true },
                { key: "state", label: "State", sortable: true },
                { key: "status", label: "Status", sortable: true },
              ]}
              data={filteredCustomers.map((c) => ({
                ...c,
                status: c.is_successful
                  ? "Success"
                  : c.is_failed
                  ? "Failed"
                  : "Pending",
                redeemed_at: new Date(c.redeemed_at).toLocaleString(),
              }))}
              renderRow={(c, idx) => (
                <tr
                  key={c.redemption_id}
                  className="hover:bg-amber-50 hover:text-gray-950 hover:font-semibold "
                >
                  <td className="py-4 px-2 border-b">
                    {" "}
                    {c.redeemed_at}
                    {/* {format(new Date(c.redeemed_at), "dd-MM-yyyy")} */}
                  </td>
                  <td className="px-2 py-4 border-b-gray-400">
                    {c.order_type === "promotional" ? "-" : c.customer_name}
                  </td>
                   <td className="py-4 px-2 border-b">{c.order_remarks}</td>
                  <td className="px-2 py-4 border-b-gray-400">
                    {c.order_type === "promotional" ? "-" : c.mobile}
                  </td>
                  <td className="py-4 px-2 border-b">{c.client_name}</td>
                  <td className="py-4 px-2 border-b">{c.qr_id}</td>
                  <td className="py-4 px-2 border-b">{c.qr_amount}</td>
                  <td className="py-4 px-2 border-b">{c.city}</td>
                  <td className="py-4 px-2 border-b">{c.state}</td>
                  <td className="py-4 px-2 border-b ">
                    <button className="bg-green-600 px-2 text-white rounded-lg font-semibold">
                      {c.status}
                    </button>
                  </td>
                </tr>
              )}
            >
              {filteredCustomers.length === 0 && (
                <tr>
                  <td colSpan={9} className="text-center text-gray-500 py-4">
                    No redeemed customer data available.
                  </td>
                </tr>
              )}
            </SortableTable>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CustomerRedemptionReport;
